// extracted by mini-css-extract-plugin
export default {"box":"Box_box__rbdR8","padding":"Box_padding__e8RyY","flex":"Box_flex__5dO1m"};